
export default {
  auth_request: (state) => {
    state.status = 'loading';
  },
  auth_success: (state, data) => {
    state.status = 'success';
    state.token = data.token;
    state.refresh_token = data.refresh_token;
    state.roles = data.roles;
    state.email = data.email;
    state.first_name = data.first_name;
    state.school_flag = data.school_flag;
    state.mfa_data = '';
    state.mfa_status = '';
  },
  mfa_success: (state, data) => {
    state.mfa_first_name = data.first_name;
    state.mfa_email = data.email;
    state.mfa_status = 'success';
    state.mfa_data = data;
  },


  auth_error: (state, err_data) => {
    state.status = 'error';
    if(err_data.message == 'Bad credentials') {
      err_data.message = 'Invalid user credentials';
    }
    state.err_message = err_data.message;
  },
  logout: (state) => {
    state.status = '';
    state.mfa_status = '';
    state.mfa_first_name = '';
    state.mfa_email = '';
    state.token = '';
    state.roles = '';
    state.email = '';
    state.first_name = '';
    state.refresh_token = '';
    state.switch_flag = '';
    state.page_url = '';
    state.active_tab = '';
    state.user_accountid = '';
    state.sidebar_menu_minimized = '';
    state.school_flag = '';
    state.switch_admin_username = '';
    state.switch_admin_account_flag = '';
    state.switch_admin_enterprise_isreadonly = '';
    state.switch_admin_enterprise_flag = '';
    state.switch_admin_firstname = '';
    state.switch_admin_roles = '';
    state.tasklist_title = '';
    state.multi_user_logged_in_time = '';
    state.enterprise_type = '';
    state.switch_admin_enterprise_type = '';
    state.invoice_due_modal_date = '';
  },
  headings_tasks: (state, data) => {
    state.sub_tasks_obj = data;
  },
  subtasks: (state, data) => {
    state.sub_tasks = data;
  },
  refresh_token: (state, data) => {
    state.status = 'success';
    state.token = data.token;
    state.refresh_token = data.refresh_token;
  },
  set_flash_msg: (state, data) => {
    if(data.status == 'danger') {
      state.FLASH.danger = data.msg;
    }
    else if(data.status == 'success') {
      state.FLASH.success = data.msg;
    }
  },
  switch_user: (state, data) => {
    state.switch_flag = data;
  },
  active_tab: (state, data) => {
    state.page_url = data.page_url;
    state.active_tab = data.active_tab;
    state.active_sub_tab = data.active_sub_tab;
  },
  set_user_accountid: (state, data) => {
    state.user_accountid = data;
  },
  mentee_comparison_page_size: (state, data) => {
    state.menteeComparisonPageSize = data;
  },
  invoice_due_order_id: (state, data) => {
    state.invoice_order_id = data;
  },
  invoice_due_modal_date: (state, data) => {
    state.invoice_due_modal_date = data;
  },
  search_parameters: (state, data) => {
    state.search_parameters = data;
  },
  sidebar_menu_minimized: (state, data) => {
    state.sidebar_menu_minimized = data;
  },
  switch_admin_user: (state, data) => {
    state.switch_admin_username = data.switch_admin_username;
    state.switch_admin_firstname = data.switch_admin_firstname;
    state.switch_admin_roles = data.switch_admin_roles;
    state.switch_admin_account_flag = data.switch_admin_account_flag;
    state.switch_admin_enterprise_flag = data.switch_admin_enterprise_flag;
    state.switch_admin_enterprise_isreadonly = data.switch_admin_enterprise_isreadonly;
  },
  tasklist_title: (state, data) => {
    state.tasklist_title = data.title;
  },  
  set_search_accounts: (state, data) => {
    const accountData = data.account;
    const adminData = data.admin;
    for(var key in accountData){
      if (accountData[key]) {
        state.search_accounts[key] = accountData[key];
      }
    }
    for(var key in adminData){
      if (adminData[key] != "" 
          && (key === 'admin_fname' || key === 'admin_lname' || key === 'admin_email' || key === 'admin_title')) {
        state.search_accounts[key] = adminData[key];
      }
    }
  },
  clear_search_accounts: (state) => {
    let stateSearchAccountData = state.search_accounts;

    Object.keys(stateSearchAccountData).forEach(key => {
      state.search_accounts[key] = '';
    });
  },
  assessment_sections: (state, data) => {
    state.assessment_section_obj = data;
  },
  forms_manager: (state, data) => {
    state.forms_manager = data;
  },
  search_enterprise_parameters: (state, data) => {
    state.search_enterprise_parameters = data;
  },
  set_search_enterprises: (state, data) => {
    const accountData = data.account;
    const adminData = data.admin;
    for(var key in accountData){
      if (accountData[key]) {
        if (key === 'status' && Array.isArray(accountData[key])) {
          state.search_enterprises[key] = '';  
        } else {
          state.search_enterprises[key] = accountData[key];
        }
      }
    }
    for(var key in adminData){
      if (adminData[key] != "" 
          && (key === 'admin_fname' || key === 'admin_lname' || key === 'admin_email' || key === 'admin_title')) {
        state.search_enterprises[key] = adminData[key];
      }
    }
  },
  clear_search_enterprises: (state) => {
    let stateSearchAccountData = state.search_enterprises;

    Object.keys(stateSearchAccountData).forEach(key => {
      state.search_enterprises[key] = '';
    });
  },
  search_enterprise_locations: (state, data) => {
    for(var key in data) {
      state.search_enterprise_locations[key] = data[key];
    }
  },
  clear_search_enterprise_locations: (state) => {
    let stateSearchAccountData = state.search_enterprise_locations;

    Object.keys(stateSearchAccountData).forEach(key => {
      state.search_enterprise_locations[key] = '';
    });
  },
  search_enterprise_purchasing_history: (state, data) => {
    for(var key in data) {
      state.search_enterprise_purchasing_history[key] = data[key];
    }
  },  
  clear_search_enterprise_purchasing_history: (state) => {
    state.search_enterprise_purchasing_history = {};
  },  
  set_user_locations: (state, data) => {
    state.user_locations = data;
  },
  clear_user_locations: (state, data) => {
    state.user_locations = [];
  },
  set_multi_user_logged_time: (state, data) => {
    state.multi_user_logged_in_time = data;
  },
  set_enterprise_type: (state, data) => {
    state.enterprise_type = data;
  },  
  introduction_template: (state, data) => {
    state.introduction_template = data;
  },
  introduction_template_display: (state, data) => {
    state.introduction_template_display = data;
  },
  pathway_steps: (state, data) => {
    state.pathway_steps = data;
  },
  create_account_obj: (state, data) => {
    state.create_account_obj = data;
  },
  create_account: (state, data) => {
    state.create_account_uid = data.uid;
    state.create_account_accountId = data.accountId;
    state.create_account_email = data.email;
  },
  ea_roles_update: (state, data) => {
    state.roles = data;
  },
  ea_switch_roles_update: (state, data) => {
    state.switch_admin_roles = data;
  },
  ea_mentee_pathway_report: (state, data) => {
    state.ea_mentee_pathway_report = data;
  },
  create_account_billing: (state, data) => {
    state.create_account_billing_packageId = data.packageId;
    state.create_account_billing_type = data.type;
  },
  catalog_pathway_steps: (state, data) => {
    state.catalog_pathway_steps = data;
  },
  catalog_pathway_steps_flag: (state, data) => {
    state.catalog_pathway_steps_flag = data;
  },
  multilocation_switch_roles_attach: (state, data) => {
    state.switch_admin_roles = data.switch_admin_roles;
    state.switch_flag = data.switch_flag;
  },
  multilocation_roles_attach: (state, data) => {
    state.roles = data;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js